'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function serviceAssistentController($window, serviceAssistentService) {

    var vm = this;
    vm.showAssistent = false;
    vm.showCallMeNow = false;
    vm.numberToCall = '';
    vm.toggleAssistent = toggleAssistent;
    vm.stuurBelVerzoek = stuurBelVerzoek;

    function toggleAssistent() {
        vm.showAssistent = !vm.showAssistent;
    }

    function stuurBelVerzoek() {
        serviceAssistentService.callMeNow(vm.numberToCall, $window.location.href, vm.label, vm.onderwerp).then(function (response) {
            if (!response.error) {
                vm.showCallMeNow = false;
                vm.showAssistent = true;
            } else {
                vm.showError('Het verzoek kon niet worden verzonden, probeer het later nog eens.');
            }
        }).catch(function () {
            vm.showError('Het verzoek kon niet worden verzonden, probeer het later nog eens.');
        });
    }
}

serviceAssistentController.$inject = ['$window', 'serviceAssistentService'];

exports.default = serviceAssistentController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/service-assistent/service-assistent.controller.js
// module id = 903
// module chunks = 0